import { WHY_ICONS, IMAGES } from "../data/clinic";
import { useLang } from "../i18n/LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";

export default function WhyUs() {
  const { t } = useLang();
  const w = t.why;

  return (
    <section id="why-us" data-testid="why-us-section" className="relative bg-brand-bg py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <Eyebrow>{w.eyebrow}</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-display text-4xl font-normal leading-tight tracking-tight text-brand-ink md:text-5xl">
            {w.heading}
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          <Reveal className="lg:row-span-2">
            <div className="relative h-full min-h-[320px] overflow-hidden rounded-3xl spotlight shadow-xl shadow-brand-ink/10">
              <img
                src={IMAGES.clinicInterior}
                alt="Modern, hygienic dental treatment room at Kesari Dental Clinic, Sector 16-17 Hisar"
                className="h-full w-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-brand-ink/80 to-transparent p-6">
                <p className="font-display text-2xl text-white">{w.imgTitle}</p>
                <p className="mt-1 text-sm text-white/80">{w.imgSub}</p>
              </div>
            </div>
          </Reveal>

          {w.items.map((item, i) => {
            const Icon = WHY_ICONS[i];
            return (
              <Reveal key={item.title} delay={(i % 2) * 0.08} className="h-full">
                <div className="flex h-full items-start gap-4 rounded-3xl border border-brand-border bg-brand-surface p-6">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-brand-warm/10 text-brand-warm">
                    <Icon className="h-5 w-5" strokeWidth={1.5} />
                  </div>
                  <div>
                    <h3 className="font-display text-lg text-brand-ink">{item.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-brand-inksoft">{item.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
